var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScenarios = function SvgScenarios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "matrix(1 0 0 -1 16 8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeWidth: 1.5,
    d: "M2.774 11.144c-1.003 1.12-1.024 2.81-.104 4a34 34 0 0 0 6.186 6.186c1.19.92 2.88.899 4-.104a92 92 0 0 0 8.516-8.698 1.95 1.95 0 0 0 .47-1.094c.164-1.796.503-6.97-.902-8.374s-6.578-1.066-8.374-.901a1.95 1.95 0 0 0-1.094.47 92 92 0 0 0-8.698 8.515Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4651",
    d: "m11.086 12.909.53-.53zm2.247-2.243-.53.53zm-2.115 4.79.53.531zm-2.551-.131.53-.531zm5.863-4.794a.75.75 0 0 0-1.06-1.062zm-7.06 4.928a.75.75 0 1 0 1.06 1.062zm5.594-3.302a.75.75 0 1 0 1.447.397zm-4.24 1.684a.75.75 0 0 0-1.494-.132zm2.792-1.463c-.39-.389-.458-.622-.463-.726-.004-.078.02-.225.27-.475l-1.06-1.062c-.417.417-.744.955-.708 1.618.034.638.397 1.203.901 1.707zm-.193-1.201a.977.977 0 0 1 1.38.02l1.06-1.062c-.964-.962-2.53-.987-3.5-.02zm-.735 3.749c-.297.296-.533.34-.71.32-.21-.023-.484-.155-.782-.452l-1.06 1.061c.444.443 1.015.809 1.678.882.697.077 1.367-.184 1.934-.75zm-.132-1.486c.396.395.497.654.508.806.008.121-.03.335-.376.68l1.06 1.061c.519-.518.862-1.132.812-1.845-.048-.683-.445-1.266-.944-1.764zm3.307-2.243.667-.666-1.06-1.062-.667.666zm-5.726 3.597-.667.665 1.06 1.062.666-.666zm4.666-3.597c.266.265.35.635.261.96l1.447.397a2.49 2.49 0 0 0-.648-2.42zm-3.607 3.597a1.22 1.22 0 0 1-.372-.953L7.33 13.71a2.72 2.72 0 0 0 .807 2.146z"
  })));
};
export default SvgScenarios;